import PagePlaceholder from "./PagePlaceholder";

const UsageStats = () => <PagePlaceholder title="Usage Stats" />;

export default UsageStats;
